<template>
	<div  :class="{'container-fluid': !isSettingsComponent}">
		<time-logs-toolbar v-if="!isSettingsComponent" heading="Time Log Settings"></time-logs-toolbar>

		<div class="container">
			<h2 v-if="isSettingsComponent">Payroll Settings</h2>

			<!--
			<onboarding-card title="Set up your payroll intervals" 
				name="Time Log Settings" 
				setting-key="timeLogSettings" 
				next-link="/setup/unions">

				<p>{{$store.appName}} needs to know when your payroll starts and how often, so it can group Time Logs together appropriately.</p>

				<p>Its also important to specify what types of overtime (1.5x, 2x, 2.5x) you may pay your employees so we can show only the options that are relevant.</p>
			</onboarding-card>
			-->

			<vue-form v-on:submit="save">

				<h3>Overtime Multipliers</h3>
				<p>Select all options that your company uses for overtime pay. These will appear as options to enter hours into on the Clock Out page.</p>

				<field label="1.5x" col-class="col-md-4" v-model="payload.uses_overtime_15x" :params="{type: 'boolean'}"></field>	

				<field label="2x" col-class="col-md-4" v-model="payload.uses_overtime_2x" :params="{type: 'boolean'}"></field>	
				
				<field label="2.5x" col-class="col-md-4" v-model="payload.uses_overtime_25x" :params="{type: 'boolean'}"></field>	

				<h3>Pay Period</h3>

				<field label="Interval" col-class="col-md-4" v-model="payload.interval" :params="{type: 'select', options: periodIntervalOptions}"></field>	

				<field label="Initial Pay Period Start" col-class="col-md-4" v-model="payload.initial_payday" :params="{type: 'date'}">
					
					<!--<div class="text-muted">This should represent the first day that your pay period starts</div>-->
				</field>

			</vue-form>
		</div>

	</div>
</template>

<script>
import VueForm from "@/components/VueForm"
import FormGroup from "@/components/FormGroup"
import Field from "@/components/Field"
import TimeLogsToolbar from "./TimeLogsToolbar"

import OnboardingCard from "@/components/OnboardingCard"

export default {

	name: 'TimeLogSettings',
	components: {
		TimeLogsToolbar,
		VueForm,
		FormGroup,
		Field,
		OnboardingCard
	},
	props: ["isSettingsComponent"],
	data() {
		return {
			payload: {
				uses_overtime_15x: 0,
				uses_overtime_2x: 0,
				uses_overtime_25x: 0,
				interval: null,
				initial_payday: null
			},
			periodIntervalOptions: [
				{text: "Weekly (every 7 days)",value: "weekly"},
				{text: "Bi-Weekly (every 14 days)",value: "biweekly"},
				{text: "Semi-Monthly (twice/month)",value: "semimonthly"},
				{text: "Monthly (once/month)",value: "monthly"},
			]
		}
	},
	computed: {
	},
	methods: {
		save() {
			this.saveRecord("TimeLogSetting",this.payload)
		},
		fetchSettings() {
			let vm = this

			this.spinner(true)

			this.getJSON("TimeLogSetting/get").then(response => {
				vm.spinner(false)

				if (response.data.length > 0)
					vm.payload = response.data[0]
			})
		}
	},
	created() {
		this.fetchSettings()
	}

}
</script>

<style type="text/css" scoped>
	.container {
		max-width: 600px!important;
	}
</style>